import { BaseComponentSingleton } from '../BaseComponentSingleton';

class StickyProgress extends BaseComponentSingleton {
  constructor(rootElement: HTMLElement) {
    super(rootElement);

    this.rootElement = rootElement;
  }

  private progressIndicator = document.createElement('progress');

  private get scrollPercentage() {
    const rect = document.body.getBoundingClientRect();
    const percentage = Math.abs(rect.top / (document.body.clientHeight - innerHeight));
    return percentage;
  }

  private handleScroll = () => {
    this.progressIndicator.setAttribute('value', `${this.scrollPercentage}`);
  };

  public init() {
    this.progressIndicator.className = 'stickyprogress';
    document.body.appendChild(this.progressIndicator);

    window.addEventListener('scroll', this.handleScroll, false);

    this.handleScroll();
  }
}

export default StickyProgress;
